import React from 'react';
import PropTypes from 'prop-types';

import { S25_ULTRA_SLUG, S25_PLUS_SLUG } from 'config/constants';
import { P1_P2_TABS, P3_TABS } from '../data';
import styles from '../S25.module.scss';

export default function S25Features({ slug = '' }) {
    const isMobile = window.matchMedia('(max-width: 1024px)').matches;
    const TABS = slug === S25_ULTRA_SLUG ? P3_TABS.FEATURES : P1_P2_TABS.FEATURES;
    const banner = slug === S25_ULTRA_SLUG
        ? isMobile ? '/s25/p3/banner/mo.jpg' : '/s25/p3/banner/pc.jpg'
        : isMobile ? '/s25/p1_p2/banner/mo.jpg' : '/s25/p1_p2/banner/pc.jpg';

    const [tabValues, setTabValues] = React.useState({
        TAB_1: TABS.TAB_1[0].key,
        TAB_2: TABS.TAB_2[0].key,
        TAB_3: TABS.TAB_3[0].key
    });

    const touchStartX = React.useRef(null);
    const touchEndX = React.useRef(null);

    const handleTouchStart = (event) => {
        touchStartX.current = event.touches[0].clientX;
    };

    const handleTouchMove = (event) => {
        touchEndX.current = event.touches[0].clientX;
    };

    const handleTouchEnd = (tabKey) => {
        if (!touchStartX.current || !touchEndX.current) return;

        const deltaX = touchStartX.current - touchEndX.current;

        if (Math.abs(deltaX) > 50) {
            if (deltaX > 0) {
                changeTab(tabKey, 'left');
            } else {
                changeTab(tabKey, 'right');
            }
        }

        touchStartX.current = null;
        touchEndX.current = null;
    };

    const changeTab = (tabKey, direction) => {
        const currentIndex = TABS[tabKey].findIndex((tab) => tab.key === tabValues[tabKey]);
        let newIndex = currentIndex;

        if (direction === 'left' && currentIndex < TABS[tabKey].length - 1) {
            newIndex = currentIndex + 1;
        } else if (direction === 'right' && currentIndex > 0) {
            newIndex = currentIndex - 1;
        }

        if (newIndex !== currentIndex) {
            const newTabKey = TABS[tabKey][newIndex].key;

            setTabValues((prev) => ({ ...prev, [tabKey]: newTabKey }));
        }
    };

    const handleTabChange = (tabKey, newValue) => {
        setTabValues((prev) => ({ ...prev, [tabKey]: newValue }));
    };

    /* eslint-disable camelcase */
    const getImageUrl = (tabKey) => {
        const tab = TABS[tabKey].find((tab) => tab.key === tabValues[tabKey]);

        if (!tab) return null;

        const { key, mo_image, pc_image, mo_image_qualcomm, pc_image_qualcomm, mo_image_exynos, pc_image_exynos } = tab;

        if (key === 'p1_p2_processor') {
            return slug === S25_PLUS_SLUG
                ? (isMobile ? mo_image_qualcomm : pc_image_qualcomm)
                : (isMobile ? mo_image_exynos : pc_image_exynos);
        }

        return isMobile ? mo_image : pc_image;
    };
    /* eslint-enable camelcase */

    return (
        <div>
            <img src={banner} className={styles.image} />
            {Object.entries(TABS).map(([tabKey, tabs]) => (
                <div key={tabKey}>
                    <div className={styles.tabs}>
                        {tabs.map((tab) => (
                            <button
                                key={tab.key}
                                onClick={() => handleTabChange(tabKey, tab.key)}>
                                <span className={tab.key === tabValues[tabKey] ? styles.active : ''}>
                                    {tab?.label}
                                </span>
                            </button>
                        ))}
                    </div>
                    <div
                        onTouchStart={handleTouchStart}
                        onTouchMove={handleTouchMove}
                        onTouchEnd={() => handleTouchEnd(tabKey)}>
                        <img
                            src={getImageUrl(tabKey)}
                            className={styles.image}
                            alt='Tab Content'/>
                    </div>
                </div>
            ))}
        </div>
    );
}

S25Features.propTypes = {
    slug: PropTypes.string
};
